export const SUPPORTED_PAYMENT_METHODS = ['ACQUIRING', 'VTB_ONLINE_SECTION'] as const;
